// extracted by mini-css-extract-plugin
export default {"container":"Login_container__+Ihqx","stack":"Login_stack__RP9e4"};